<template>
  <component :is="currentComponent" :key="componentKey" />
</template>

<script>
import Tag from './Tag.vue'
import TagMobile from './TagMobile.vue'
import { isMobile, addResizeListener } from '@/utils/device'

export default {
  name: 'TagIndex',
  data() {
    return {
      isMobileDevice: false,
      removeResizeListener: null,
      componentKey: 'init'
    }
  },
  computed: {
    currentComponent() {
      return this.isMobileDevice ? TagMobile : Tag
    }
  },
  created() {
    this.isMobileDevice = isMobile()
  },
  mounted() {
    let rafId = null
    const onResize = () => {
      if (rafId) return
      rafId = requestAnimationFrame(() => {
        const next = isMobile()
        if (next !== this.isMobileDevice) {
          this.isMobileDevice = next
          this.componentKey = next ? 'm' : 'pc'
        }
        rafId = null
      })
    }
    this.removeResizeListener = addResizeListener(onResize)
  },
  beforeDestroy() {
    if (this.removeResizeListener) {
      this.removeResizeListener()
      this.removeResizeListener = null
    }
  }
}
</script>

<style scoped>
</style>

